import { combineReducers } from "redux";
import editor from "./editor";

export default combineReducers({
  editor: editor,
});
